import { Injectable } from '@angular/core';
import { PlayConfigurationModel } from './models/animation/play-configuration.model';
import { TimerangeModel } from './models/animation/timerange.model';
import { plainToClass } from 'class-transformer';
import { get } from 'lodash';
import { SetConfigurationModel } from './models/animation/set-configuration.model';
import { ChapterModel } from '../story/models/chapter.model';

declare const Human: any;

interface TimelinePlayParams {
  [key: string]: any;
}

@Injectable({
  providedIn: 'root'
})
export class AnimationService {
  playParams: PlayConfigurationModel; 

  constructor(
  ) { }

  getChapterLocalTimerange(chapterId: string): TimerangeModel {
    const chapter = Human.timeline.activeRoot._chapters.find(_chapter => _chapter.id === chapterId);
    return plainToClass(TimerangeModel, chapter.timeRange as object);

    // Human.timeline.activeRoot._nowBranch;
    // get branch timeline:               <branch>.getTimeframe()
    // convert local to globalTime:       Human.timeline.activeRoot.mapBranchTime(<branch>, 1);
    // scrub animation using globalTime:  Human.timeline.scrub(globalTime):  
  }

  mapGlobalTimeToLocal(time: number, params = {}): {branch: any, time: number, index: number} {
    const localTime = Human.timeline.activeRoot.mapGlobalTime(time, params);

    // BUG: When globalTime is zero, localTime is -3
    if (localTime.time < 0) {
      localTime.time = 0;
    }

    return localTime;
    // return Human.timeline.activeRoot.mapGlobalTime(time, params);
  }

  mapLocalTimeToGlobal(chapterId: string, time: number): number {
    const branch = Human.timeline.activeRoot._chapters.find(chapter => chapter.id === chapterId);
    return Human.timeline.activeRoot.mapBranchTime(branch, time);
  }

  isChapterAnimated(chapter) {
    const isAnimated = chapter.timelineMap
      .filter(timeline => {
        return get(timeline, 'data.timeline') !== 'dummy' &&
          get(timeline, 'data.timeline.id') !== 'dummy' &&
          get(timeline, 'data.timeline.id.id') !== 'dummy';
      }).length > 0;

    return isAnimated;  
  }

  isChapterLooped(chapter: ChapterModel) {
    if (get(chapter, 'loop') === true) {
      return true;
    }

    if (get(chapter, 'ui.play.count') === -1) {
      return true;
    }

    return false;
  }


  scrub(options: SetConfigurationModel) {
    const which = options.which ? options.which : 'first';
    Human.timeline.scrub({
      time: options.time,
      borderCondition: {
        which: which,
        direction: 'forward'
      }
    });

  }

  getTimeFrame() {
    return Human.timeline.getTimeFrame();
  }

  getTime() {
    return Human.timeline.time;
  }

  isPlaying() {
    return Human.timeline.playing;
  }

  hasChapterFinished(chapterId: string) {
    const timerange = this.getChapterLocalTimerange(chapterId);
    const localTime = this.mapGlobalTimeToLocal(Human.timeline.time);
    
    return (localTime.time === timerange.lastTime);
  }

  play(options: PlayConfigurationModel) {
    // spread props, but filter any that are undefined.
    // The engine does `hasOwnProperty` checks, so `undefined` params can slip through the cracks if not careful
    this.playParams = Object.keys(options).reduce<PlayConfigurationModel>(
      (acc, option) => {
        if (acc[option] === undefined) {
          delete acc[option];
        }
        return acc;
      },
      { ...options }
    );
    
    Human.timeline.play( this.playParams );
  }

  rewind(chapterId: string) {
    const resetTime = this.mapLocalTimeToGlobal(chapterId, 0);
    this.scrub({time: resetTime, which: 'second'});
  }

  unpause(chapterId: string) {
    // If the user unpauses at the end of an animation, it starts playing the next chapter, so this rewinds first
    if (this.hasChapterFinished(chapterId)) {
      this.rewind(chapterId);
    }

    Human.timeline.unpause();
  }

  pause() {
    Human.timeline.pause();
  }

  // Human.timeline.scrub({
    //   time: 1
    // });

    // Human.timeline.activeRoot._nowBranch;
    // Human.timeline.activeRoot.mapGlobalTime(Human.timeline.time);

    // Sequence of events:
    // Human.timeline.activeRoot._nowBranch;
    // get branch timeline:               <branch>.getTimeframe()
    // convert local to globalTime:       Human.timeline.activeRoot.mapBranchTime(<branch>, 1);
    // scrub animation using globalTime:  Human.timeline.scrub(globalTime):  

    // Border conditions:
    // Human.timeline.borderConditions (both end of chapter and start of another)
    // Human.timeline.scrub({ time: 7, borderCondition: { which: 'second', direction: 'forward' }}) == start
    // Human.timeline.scrub({ time: 7, borderCondition: { which: 'first', direction: 'forward' }}) == end

    // Events
    // timeline.scrubbed (globalTime)
    // timeline.play

    // Playing (start conditions, end conditions, play conditions)
    // Human.timeline.play({ startChapterId: ..., numChapters: 1, loop: true })

}
